import { render, staticRenderFns } from "./CommentChild.vue?vue&type=template&id=6aac0078&scoped=true"
import script from "./CommentChild.vue?vue&type=script&lang=js"
export * from "./CommentChild.vue?vue&type=script&lang=js"
import style0 from "./CommentChild.vue?vue&type=style&index=0&id=6aac0078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac0078",
  null
  
)

export default component.exports